import {useEffect, useRef} from "react"
import {useTranslation} from "react-i18next"
import {useLexiconsContext} from "../../reactContext/contextCustomHooks/useLexiconsContext"
import AddLexiconsModalForm from "../../forms/lexicons/AddLexiconsModalForm"
import SelectlexiconsmodalForm from "../../forms/lexicons/SelectLexiconsModalForm"
import closeIcon from "../../assets/icon/close.svg"
import useClickOutside from "../../tools/useClickOutside"
import ScrollingMod from "../../tools/ScrollingMod"

export default function LexiconsModal({type, mutateStProject}) {
    const {t} = useTranslation()
    const {setLexiconsAction} = useLexiconsContext()
    const lexiconModalModalRef = useRef(null)

    const closeModal = () => {
        setLexiconsAction({type: "CLEAN_LEXICONS_CONTEXT"})
        ScrollingMod(false)
    }

    useClickOutside(lexiconModalModalRef, () => {
        closeModal()
    })

    useEffect(() => {
        window.scrollTo(0, 0)
        ScrollingMod(true)
    }, [])

    return (
        <>
        <div ref={lexiconModalModalRef} className="_SECTION LEXICONS-MODAL">
            <h3>{type === "input" ? t("Create a lexicon") : t("Select a lexicon")}</h3>
            <img className="close" src={closeIcon} alt="" onClick={closeModal}/>
            {type === "input" ? <AddLexiconsModalForm closeModal={closeModal}/> : <SelectlexiconsmodalForm mutateStProject={mutateStProject}/>}
        </div>
        </>
    )
}